import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getOrganization = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `organization`);
};

export const addOrganization = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `organization/add`,
    obj,
    {
      headers,
    }
  );
};

export const GetOrganizationLookup = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `organization/lookup`);
};

export const editOrganization = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `organization/update`,
    obj,
    {
      headers,
    }
  );
};

export const deleteOrganization = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `organization/delete`,
    obj,
    {
      headers,
    }
  );
};